// /servir — a "casa" do modo equipe (213). Com uma tela só, abre direto nela.
// Para ver este menu (e o "Encerrar neste celular") mesmo com uma tela: /servir?menu=1
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { sairDoModoEquipeNesteCelular } from '@/lib/equipeLink';
import { useModoEquipe } from '@/components/feature/ModoEquipe';

const ICONE: Record<string, string> = { caixa: 'ri-bank-card-line', barraca: 'ri-store-2-line', portaria: 'ri-qr-scan-2-line' };

export default function ServirPage() {
  const { verificado, ativo, carregando, dados, recarregar } = useModoEquipe();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const verMenu = params.get('menu') === '1';
  const [confirmarSaida, setConfirmarSaida] = useState(false);
  const [saindo, setSaindo] = useState(false);

  useEffect(() => {
    if (!verificado || carregando) return; // ainda olhando a sessão deste celular
    if (!ativo) {
      navigate('/', { replace: true });
      return;
    }
    const telas = dados?.telas ?? [];
    if (!verMenu && dados && !dados.encerrado && telas.length === 1) navigate(telas[0].url, { replace: true });
  }, [verificado, ativo, carregando, dados, verMenu, navigate]);

  async function sairAgora() {
    setSaindo(true);
    try {
      await sairDoModoEquipeNesteCelular();
    } finally {
      navigate('/', { replace: true });
    }
  }

  const telas = dados?.telas ?? [];
  const primeiroNome = (dados?.nome ?? '').split(' ')[0];

  return (
    <div className="flex min-h-screen flex-col bg-primary-50 px-5 pb-6 pt-10">
      <div className="mx-auto flex w-full max-w-[420px] flex-1 flex-col">
        {!verificado || (carregando && !dados) || !dados ? (
          <div className="flex flex-1 flex-col items-center justify-center gap-3">
            <i className="ri-loader-4-line animate-spin text-4xl text-primary-600" />
            <p className="text-base font-semibold text-foreground-700">Abrindo a sua tela…</p>
          </div>
        ) : dados.encerrado ? (
          <div className="flex flex-1 flex-col items-center justify-center gap-4 text-center">
            <i className="ri-heart-3-line text-5xl text-primary-600" />
            <div>
              <h1 className="text-2xl font-extrabold text-foreground-950">O {dados.evento} terminou</h1>
              <p className="mt-1 text-lg text-foreground-700">Obrigado por servir!</p>
            </div>
            <button
              type="button"
              onClick={sairAgora}
              disabled={saindo}
              className="mt-2 flex h-14 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-[18px] bg-primary-500 px-6 text-[15px] font-bold text-white transition-colors hover:bg-primary-600 disabled:opacity-60"
            >
              <span className="flex h-5 w-5 items-center justify-center">
                <i className={saindo ? 'ri-loader-4-line animate-spin' : 'ri-arrow-right-line'} />
              </span>
              {saindo ? 'Abrindo…' : 'Continuar usando o Se Liga'}
            </button>
            <p className="text-sm text-foreground-600">
              Você sai da equipe só neste celular e volta para o Início. Lá você entra com a sua
              conta ou cria uma.
            </p>
          </div>
        ) : telas.length === 0 ? (
          <div className="flex flex-1 flex-col items-center justify-center gap-4 text-center">
            <i className="ri-lock-line text-5xl text-foreground-500" />
            <h1 className="text-2xl font-extrabold text-foreground-950">Sua função foi encerrada</h1>
            <p className="text-base text-foreground-700">A direção tirou esta função. Se foi engano, fale com a direção.</p>
            <button type="button" onClick={recarregar}
              className="h-12 rounded-2xl bg-primary-600 px-6 text-base font-bold text-white">Tentar de novo</button>
          </div>
        ) : (
          <>
            <p className="text-sm font-semibold text-primary-700">{dados.evento}</p>
            <h1 className="mt-1 text-3xl font-extrabold text-foreground-950">Olá{primeiroNome ? `, ${primeiroNome}` : ''}!</h1>
            <p className="mt-1 text-base text-foreground-700">Toque na sua tela:</p>
            <div className="mt-6 flex flex-col gap-3">
              {telas.map((t) => (
                <button key={t.url} type="button" onClick={() => navigate(t.url)}
                  className="flex h-20 items-center gap-4 rounded-3xl bg-white px-5 text-left shadow-sm ring-1 ring-primary-100 active:scale-[0.99]">
                  <i className={`${ICONE[t.tela] ?? 'ri-apps-line'} text-3xl text-primary-600`} />
                  <span className="text-xl font-extrabold text-foreground-950">{t.rotulo}</span>
                </button>
              ))}
            </div>
          </>
        )}

        {!carregando && dados && !dados.encerrado && (
          <div className="mt-auto pt-10 text-center">
            {!confirmarSaida ? (
              <button type="button" onClick={() => setConfirmarSaida(true)} className="text-sm text-foreground-500 underline">
                Encerrar neste celular
              </button>
            ) : (
              <div className="rounded-2xl bg-white p-4 text-left shadow-sm">
                <p className="text-sm text-foreground-800">
                  Este celular vai sair da função. Para voltar, a direção precisa tocar em <b>Liberar outro celular</b> e
                  você abre o link de novo.
                </p>
                <div className="mt-3 flex gap-2">
                  <button type="button" onClick={() => setConfirmarSaida(false)}
                    className="h-11 flex-1 rounded-xl bg-foreground-100 text-sm font-bold text-foreground-800">Voltar</button>
                  <button type="button" onClick={sairAgora} disabled={saindo}
                    className="h-11 flex-1 rounded-xl bg-danger-600 text-sm font-bold text-white disabled:opacity-60">
                    {saindo ? 'Saindo…' : 'Encerrar'}
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}